// eslint-disable-next-line css-modules/no-unused-class
import { IonCheckbox } from '@ionic/react';
import styles from './Checkbox.module.css';
import { useRef } from 'react';

interface CheckboxProps {
	onClick?: (e: any) => void;
	disabled?: boolean;
	label?: string;
	value?: boolean;
	name?: string;
	testId?: string;
}

export const Checkbox: React.FC<CheckboxProps> = ({ onClick, disabled, value = false, label, name, testId }) => {
	// eslint-disable-next-line no-undef
	const checkboxRef = useRef<HTMLIonCheckboxElement>(null);
	return (
		<div className={styles.checkboxContainer}>
			<div className={styles.checkbox}>
				<IonCheckbox
					onIonChange={onClick}
					ref={checkboxRef}
					disabled={disabled}
					checked={value}
					slot="start"
					name={name}
					labelPlacement="end"
					aria-label={label}
					data-testid={testId}
				>
					{label}
				</IonCheckbox>
			</div>
			{/* For testing purpose */}
			<div style={{ display: 'none' }} data-testid={`${testId}-value`}>
				{JSON.stringify(value)}
			</div>
		</div>
	);
};
